<script>
	import { formatPercent } from '../utils/format.js';


  /** @type {import('../types.d').ReadableRace} */
  export let race;

  // $: console.log($race);


  const offices = {
    'M': ['L.A. Mayor', `https://www.latimes.com/projects/2022-california-primary-election-los-angeles-live-results/`],
    '0': ['L.A. County Sheriff', `https://www.latimes.com/projects/2022-california-primary-election-los-angeles-live-results/`],
    'I': ['S.F. D.A. Recall', `https://www.latimes.com/projects/2022-california-primary-election-san-francisco-chesa-boudin-recall-live-results/`],
    'G': ['Governor', `https://www.latimes.com/projects/2022-california-primary-election-live-results/`],
    'A': ['Attorney General', `https://www.latimes.com/projects/2022-california-primary-election-live-results/`],
  };

  $: raceName = offices[$race.office][0];
  $: raceLink = offices[$race.office][1];
	$: totalVotes = $race.total_votes
	$: numOfwinners = $race.number_of_winners
	$: office = $race.office

</script>

<div class="contest">
  <table class="contest__candidates">
    
    <caption class="contest__caption watching-link text-left">
      <a href={raceLink}>
        {raceName}
        <svg class="icon">
          <use xlink:href="#icon-angle-double-right" />
        </svg>
      </a>
    </caption>
 
    <thead>
      <tr>
        <th scope="col" colSpan={1} class="contest__candidate-header">
          CANDIDATE
        </th>
        <th scope="col" class="contest__candidate-header text-right">
          %
        </th>
      </tr>
    </thead>
    <tbody>
      {#each $race.candidates as c, idx}
        {#if idx < 2}
          <tr class="candidate contest__candidate-row">
            <th
              scope="row"
              class="candidate__cell candidate__cell-name"
              class:candidate__cell-name-winner={c.is_winner | c.is_runoff}
            >
            {#if c.is_winner && numOfwinners == 1 && office!="I"}}
							<span class="candidate__cell-runoff candidate">
								Winner
							</span>
            <br>
            {/if}
            {c.given_name} {c.family_name} 
            {#if c.is_incumbent}
            <span
                  class="candidate__cell-incumbent"
                  title="Currently holds this office">i</span
                >
						{/if}
              {#if (c.is_winner && office=="I") | c.is_runoff}
							<span class="candidate__cell-winner candidate">
								✓
							</span>
              {/if}
            </th>
            <td
              class="candidate__cell candidate__cell-pct text-medium text-right">
  						{formatPercent(c.votes, totalVotes, 0)}
  								<span class="candidate__pct-symbol">%</span>
						</td>
          </tr>
        {/if}
      {/each}
    </tbody>
  </table>
</div>
{#if $race.eevp != null}
        <p class="contest__precincts">{$race.eevp}% of expected vote in</p>
    {:else}
        <p class="contest__precincts" >{$race.precincts_reporting_percent}% of precincts reporting</p>
    {/if}
